module.exports = __webpack_public_path__ + "static/img/changguan-2.02562597.png";